import React, {useState, useEffect} from 'react';
import ExpectedResults from './expected-results';
import BeneficiaresOverlaps from './overlaps';
import FollowupSubProjectPresenter from "../../../../../presenters/screens/followup-subproject.presenter";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import TotalSubproject from './totals';
import Acivity from './activity';
import styles from './index.module.scss';
import { Enums } from "@utils";
export interface IByActivityProps{    
    dataColumns: any;
    projectData: any;
	currentYear: string;
	status: any;
	screen: any;
    refresh: any;
    actData: any;
	resData: any;
    overData: any;
    tableAlert: string;
    initialValidate: boolean;
    saveTable(instance: any): void;
}

const ByActivity: React.FC<IByActivityProps> = ({initialValidate, dataColumns, currentYear, status, screen, projectData, refresh, actData, resData, overData, tableAlert, saveTable} : IByActivityProps) => {
	const [columns, setColumns] = useState(null);

	const view: IFollowupSubproject = {
        state: {
			dataColumns
        },
    };

	const presenter = new FollowupSubProjectPresenter(view);

	useEffect(() => {
        let isSubscribed = true;
        if(dataColumns?._values?.length){
            let subProject = presenter.getBeneficiariesColumns(status, currentYear, "bySubProject");
            let activity = presenter.getBeneficiariesColumns(status, currentYear, "byActivity");
            let overlap = presenter.getBeneficiariesColumns(status, currentYear, "byOverlaps");
            let totalSubPr = presenter.getBeneficiariesColumns(status, currentYear, "byTotalSubPr");
            let disaggregation = presenter.getBeneficiariesColumns(status, currentYear, "byDisaggregation");
            setColumns({subProject, activity, overlap, totalSubPr, disaggregation})
        }
        return () => {(isSubscribed = false)}
    }, [dataColumns, status?.CodigoDimension, actData, status?.EnEdicion]);

    return (
		<>
			{(resData && columns)
				?
                    <>
                        <Acivity
                            currentYear={currentYear}
                            initialValidate={initialValidate}
                            dataColumns={dataColumns}
                            columns={columns}
                            status={status}
                            screen={screen}
                            actData={actData}
                            tableAlert={tableAlert}
                            saveTable={saveTable} 
                        />

                        <div className={styles.divPpal}>
                            {resData.map((result: any, index: number) => {    
                                return (
                                    <ExpectedResults  
                                        dataColumns={dataColumns}
                                        tableAlert={tableAlert}
                                        key={index}
                                        result={result}
                                        projectData={projectData}
                                        index={index}
                                        columns={columns}
                                        screen={screen}   
                                        status={status} 
                                        saveTable={saveTable}                    
                                    />
                                );
                            })}
                        </div>
                        <BeneficiaresOverlaps 
                            overData={overData}
                            refresh={refresh}
                            resData={resData}
                            dataColumns={dataColumns}
                            columns={columns}
                            status={status} 
                            screen={screen}   
                            currentYear={currentYear}
                            saveTable={saveTable}  
                            tableAlert={tableAlert}
                        />
                        {(overData && !!resData && actData) &&
                            <TotalSubproject 
                                currentYear={currentYear}
                                tableAlert={tableAlert}
                                actData={actData}
                                overData={overData}
                                refresh={refresh}
                                resData={resData}
                                dataColumns={dataColumns}
                                columns={columns}
                                status={status} 
                                screen={actData?.data?.length ? screen : Enums.FollowupState.view}   
                                saveTable={saveTable}  
                            />
                        }
                    </>
                :   <></>
			}
		</>
	)
}

export default ByActivity;